import { render } from "./VideoWidget.vue?vue&type=template&id=885fa100"
import script from "./VideoWidget.vue?vue&type=script&lang=js"
export * from "./VideoWidget.vue?vue&type=script&lang=js"
script.render = render

export default script